import { render, staticRenderFns } from "./SetSizeTableModal.vue?vue&type=template&id=777ffc32&scoped=true"
import script from "./SetSizeTableModal.vue?vue&type=script&lang=ts"
export * from "./SetSizeTableModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777ffc32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777ffc32')) {
      api.createRecord('777ffc32', component.options)
    } else {
      api.reload('777ffc32', component.options)
    }
    module.hot.accept("./SetSizeTableModal.vue?vue&type=template&id=777ffc32&scoped=true", function () {
      api.rerender('777ffc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/SetSizeTableModal.vue"
export default component.exports